import {useState} from "react";
import "moment-timezone";
import {Link} from "react-router-dom";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import {useEffect} from "react";
// -
import Spinner from "components/loaders/spinner";

const ItemModel = {
    uid: "",
    uuid: "",
    full_address: "",
    days: {
        avg: 0,
        min: 0,
        max: 0,
    },
    level: {
        avg: 0,
        min: 0,
        max: 0,
    },
};

const ContainersListTable = ({
    itemsShown,
    selected,
    checkedAll,
    setCheckedAll,
    days,
    selectedAll,
    setSelectedAll,
    paging,
    pagerRef,
    orderingRef,
}) => {
    const sizeUp = {fontSize: "1.2rem"};

    const onClickAll = (e) => {
        let checkboxes = document.querySelectorAll('#data-list input[type="checkbox"]');
        selected.current = [];
        let selectedAll_ = {...selectedAll};
        if (e.target.checked) {
            checkboxes.forEach((checkbox) => {
                selected.current.push(checkbox.value);
                checkbox.checked = true;
            });
            selectedAll_.question = true;
            setSelectedAll(selectedAll_);
        } else {
            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
            selectedAll_.question = false;
            selectedAll_.all = false;
        }
        setSelectedAll(selectedAll_);
        setCheckedAll(e.target.checked);
    };

    const onClickCheckbox = (e) => {
        const {value} = e.target;
        if (selected.current.includes(value)) {
            selected.current = selected.current.filter((item) => item !== value);
        } else {
            selected.current.push(value);
        }
        setCheckedAll(selected.current.length === itemsShown.length);
    };

    const handleClickSelectAll = (e) => {
        let selectedAll_ = {...selectedAll};
        selectedAll_.question = false;
        selectedAll_.all = true;
        setSelectedAll(selectedAll_);
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "116px",
        backgroundColor: "white",
    };

    return (
        <>
            <div className="col-12">
                <hr className="mb-3" />
                {!itemsShown || itemsShown.length === 0 ? (
                    <div className="alert alert-secondary text-center">No hay datos disponibles</div>
                ) : (
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th colSpan="4">
                                    {pagerRef.current.paging.pages > 1 && selectedAll.question ? (
                                        <button className="btn btn-sm btn-link p-0" style={sizeUp} onClick={handleClickSelectAll}>
                                            {selectedAll.textQuestion}
                                        </button>
                                    ) : (
                                        ""
                                    )}

                                    {pagerRef.current.paging.pages > 1 && selectedAll.all ? (
                                        <span style={sizeUp}>{selectedAll.textAll}</span>
                                    ) : (
                                        ""
                                    )}
                                </th>
                                <th colSpan="3" className="text-center border-start">
                                    Días {days}
                                </th>
                                <th colSpan="3" className="text-center border-start">
                                    Nivel
                                </th>
                            </tr>
                            <tr>
                                <th key="-1" style={{width: "32px", verticalAlign: "bottom"}}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value="all"
                                        checked={checkedAll}
                                        onChange={onClickAll}
                                    />
                                </th>
                                <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                                <th className="text-center" title="Media de dias recogida" style={{width: "80px"}}>
                                    Media
                                </th>
                                <th className="text-center" title="Minimo de días sin recoger" style={{width: "80px"}}>
                                    Min
                                </th>
                                <th className="text-center" title="Máximo de días sin recoger" style={{width: "80px"}}>
                                    Max
                                </th>
                                <th className="text-center" title="Media del nivel" style={{width: "80px"}}>
                                    Medio
                                </th>
                                <th className="text-center" title="Nivel minimo recogido" style={{width: "80px"}}>
                                    Min
                                </th>
                                <th className="text-center" title="Nivel máximo recogido" style={{width: "80px"}}>
                                    Max
                                </th>
                            </tr>
                        </thead>
                        <tbody id="data-list">
                            {itemsShown.map((item, index) => (
                                <tr key={index} data-idx={index}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            name="checkSelect"
                                            value={index}
                                            readOnly={true}
                                            onChange={onClickCheckbox}
                                        />
                                    </td>
                                    <td>
                                        <Link to={"/data-view/data-container/" + item.uid + "/"} className="slx-link">
                                            {item.uid}
                                        </Link>
                                    </td>
                                    <td>{item.uuid}</td>
                                    <td>{item.full_address}</td>
                                    <td className="text-center">{item.days.avg}</td>
                                    <td className="text-center">{item.days.min}</td>
                                    <td className="text-center">{item.days.max}</td>
                                    <td className="text-center">{item.level.avg}%</td>
                                    <td className="text-center">{item.level.min}%</td>
                                    <td className="text-center">{item.level.max}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    );
};

export default ContainersListTable;
